// List of openrouter models available to the user
// This list should be updated to match the model whitelist on the backend side.
export const MODELS = [
  "anthropic/claude-opus-5.5",
  "anthropic/claude-fable-5.1",
  "anthropic/claude-opus-5",
  "anthropic/claude-fable-5",
  "anthropic/claude-sonnet-5",
  "anthropic/claude-opus-4.8",
  "anthropic/claude-opus-4.7",
  "anthropic/claude-sonnet-4.6",
  "anthropic/claude-sonnet-4.5",
  "anthropic/claude-opus-4.6",
  "anthropic/claude-opus-4.5",
  "anthropic/claude-haiku-4.5",
  "openai/gpt-6-astra",
  "openai/gpt-6-sol",
  "openai/gpt-6-luna",
  "openai/gpt-5.6-sol",
  "openai/gpt-5.6-terra",
  "openai/gpt-5.6-luna",
  "openai/gpt-5.5",
  "openai/gpt-5.5-pro",
  "openai/gpt-5.4",
  "openai/gpt-5.4-mini",
  "openai/gpt-5.4-nano",
  "openai/gpt-5.3-codex",
  "openai/gpt-5.1",
  "openai/gpt-5",
  "google/gemini-3.8-flash",
  "google/gemini-3.5-flash",
  "google/gemini-3.1-pro-preview",
  "google/gemini-3.1-flash-lite",
  "deepseek/deepseek-v4.1-flash",
  "deepseek/deepseek-v4-pro",
  "deepseek/deepseek-v4-flash",
  "deepseek/deepseek-v3.2",
  "meta-llama/llama-4-maverick",
  "x-ai/grok-4.7",
  "x-ai/grok-4.3",
  "x-ai/grok-4.20",
  "qwen/qwen3.8-max-0902",
  "qwen/qwen3.8-flash",
  "qwen/qwen3.7-max",
  "qwen/qwen3-coder",
  "z-ai/glm-5.3",
  "z-ai/glm-5.3-flash",
  "moonshotai/kimi-k3",
  "moonshotai/kimi-k2.6",
  "moonshotai/kimi-k2.5",
  "mistralai/mistral-medium-3-5",
  "mistralai/codestral-2508",
  "mistralai/devstral-2512",
  "mistralai/mistral-medium-3.1",
] as const;

// Default model for chat surfaces when the host app doesn't pin one via
// config.model.defaultModel. Kept explicit (rather than MODELS[0]) so
// reordering MODELS — e.g. listing a premium model first — can never
// silently change what unconfigured embeds run on.
export const DEFAULT_MODEL: (typeof MODELS)[number] = "anthropic/claude-opus-5";
